module.exports = __webpack_public_path__ + "media/images/athletes/1347-1e64b0eac08d972380b141fba94ff3ac.png";